import React from 'react';

function CalculatorTitle(props) {
    return (
        <div className="calculatorTitle">
            {props.value}
        </div>
    )
}

export default CalculatorTitle;